import * as React from 'react'

function SvgProfileEditIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={8} cy={5} r={3.2} stroke="currentColor" strokeWidth={1.6} />
      <path
        d="M2 17c0-2.761 2.686-5 6-5"
        stroke="currentColor"
        strokeWidth={1.6}
      />
      <path
        d="M9.96 15.206l5.824-5.823M17.229 7.981l-1 1"
        stroke="currentColor"
        strokeWidth={2}
      />
      <path
        d="M7.971 17.146l.933-2.035 1.102 1.102-2.035.933z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgProfileEditIcon
